import { render, staticRenderFns } from "./WorkerParticipationProcedure.vue?vue&type=template&id=23433c0f&"
import script from "./WorkerParticipationProcedure.vue?vue&type=script&lang=js&"
export * from "./WorkerParticipationProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports